import type { ValueGetterParams } from 'ag-grid-community';
import type { OrganizationUserType, UserWithOrganizationType } from '../../types/user';

/**
 * ユーザが所属する組織を調べて商社コード一覧を返す
 * @param [ValueGetterParams]
 * @returns [string[]] - 商社コードの配列
 */
const tradingCompanyValueGetter = (params: ValueGetterParams): string[] => {
  const data: UserWithOrganizationType = params.data;
  const organizations: OrganizationUserType[] | undefined = data.organizations;
  // console.log(params.data);
  const tradingCompanyCodes: string[] = organizations ? organizations.map((org) => org.tradingCompanyCode) : [];
  const filteredTradingCompanyCodes: string[] = Array.from(new Set(tradingCompanyCodes));
  // console.log(filteredTradingCompanyCodes);
  return filteredTradingCompanyCodes;
};

export default tradingCompanyValueGetter;
